<template>
  <div class="whs-hero__control whs-hero__control--adults" ref="guests">
    <div class="whs-hero__label">Гостей</div>
    <input
      class="whs-hero__input is-set"
      @click="toggleDropdown"
      :value="adultsPlusChildren"
      readonly
      placeholder="Даты заезда/выезда"
    >
    <div class="whs-hero__select-simulator whs-icon" :class="{'open': open}"></div>
    <transition name="fade">
      <div v-show="open" class="whs-guests-container">
        <div>
          <div class="whs-guests-label">Взрослых</div>
          <div class="whs-guests-calc">
            <div
              class="whs-guests-calc--dec whs-icon"
              @click="setAdults(-1)"
              :class="{active: isActiveAdults(-1)}"
            ></div>
            <div class="whs-guests-calc--value">{{ adults }}</div>
            <div
              class="whs-guests-calc--inc whs-icon"
              @click="setAdults(1)"
              :class="{active: isActiveAdults(1)}"
            ></div>
          </div>
        </div>
        <div>
          <div class="whs-guests-label">Детей</div>
          <div class="whs-guests-calc">
            <div
              class="whs-guests-calc--dec whs-icon"
              @click="setChildren(-1)"
              :class="{active: isActiveChildren(-1)}"
            ></div>
            <div class="whs-guests-calc--value">{{ children.length }}</div>
            <div
              class="whs-guests-calc--inc whs-icon"
              @click="setChildren(1)"
              :class="{active: isActiveChildren(1)}"
            ></div>
          </div>
        </div>
        <div class="whs-guests-children-row" v-show="children.length > 0">
          <div class="whs-guests-label">Возраст детей</div>
          <div class="whs-guests-children">
            <select
              class="whs-guests-select"
              v-for="(child, index) in children"
              :key="index"
              :value="child"
              @change="setChildAge(index, $event)"
            >
              <option value="0" :key="0">0</option>
              <option v-for="num in 17" :key="num">{{ num }}</option>
            </select>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Guests',
  created: function() {
    const vm = this;
    window.addEventListener('click', e => {
      if ((vm.$refs.guests && vm.$refs.guests.contains(e.target)) || !vm.open)
        return;
      vm.closeDropdown();
    });
  },
  data: function() {
    return {
      open: false
    };
  },
  computed: {
    ...mapState('hero', ['adults', 'children']),
    adultsPlusChildren: {
      get: function() {
        return `${this.adults} ${this.adults === 1 ? 'взрослый' : 'взрослых'}${
          this.children.length > 0
            ? this.children.length === 1
              ? ', ' + this.children.length + ' ребенок'
              : ', ' + this.children.length + ' детей'
            : ''
        }`;
      }
    }
  },
  methods: {
    toggleDropdown() {
      this.open = !this.open;
    },
    closeDropdown() {
      this.open = false;
    },
    setAdults(index) {
      if (!this.isActiveAdults(index)) return;
      this.$store.commit('hero/updateAdults', index);
    },
    isActiveAdults(index) {
      const adults = this.adults + index;
      if (adults < 1 || adults > 6) return false;
      return true;
    },
    isActiveChildren(index) {
      const children = this.children.length + index;
      if (children < 0 || children > 4) return false;
      return true;
    },
    setChildren(index) {
      if (!this.isActiveChildren(index)) return;
      this.$store.commit('hero/updateChildren', index);
    },
    setChildAge(index, $event) {
      this.$store.commit('hero/updateChildAge', {
        index,
        age: parseInt($event.target.value, 10)
      });
    }
  }
};
</script>

<style scoped>
.whs-hero__control--adults {
  flex: 2 1 250px;
}
.whs-hero__input {
  cursor: pointer;
}
.whs-guests-container {
  z-index: 1;
  width: calc(100% - 16px);
  padding: 12px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  justify-items: center;
  grid-gap: 18px;
  right: 8px;
  position: absolute;
  background-color: var(--color-bg-dark);
  box-shadow: 0 0 1px var(--color-alt), 0 0 8px var(--color-bg-dark),
    1px 0 12px var(--color-bg);
}
.whs-guests-label {
  font-size: 11px !important;
  color: var(--color-text-5) !important;
  font-weight: 600;
  text-align: center;
  margin-bottom: 12px;
}
.whs-guests-calc {
  width: 100%;
  max-width: 110px;
  display: grid;
  grid-template-columns: 32px minmax(min-content, 100px) 32px;
  grid-gap: 1px;
}
.whs-guests-calc--inc,
.whs-guests-calc--dec {
  cursor: pointer;
  background-color: var(--color-bg-dark);
}
.whs-guests-calc--inc,
.whs-guests-calc--dec,
.whs-guests-calc--value {
  width: 100%;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.whs-guests-calc--inc.active,
.whs-guests-calc--dec.active {
  background-color: var(--color-alt-5);
}
.whs-guests-calc--inc:before,
.whs-guests-calc--dec:before {
  width: 100%;
  text-align: center;
  content: '\f067';
  font-size: 18px !important;
  color: var(--color-alt-5) !important;
}
.whs-guests-calc--dec:before {
  content: '\f068';
}
.whs-guests-calc--inc.active:before,
.whs-guests-calc--dec.active:before {
  color: var(--color-main) !important;
}
.whs-guests-calc--value {
  font-weight: 700;
  font-size: 16px !important;
  background-color: var(--color-bg-dark);
}
.whs-guests-children-row {
  grid-column: 1/3;
}
.whs-guests-children {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 4px;
  max-width: 400px;
}
.whs-guests-select {
  width: 100%;
  background-color: #fff;
  outline: none;
  line-height: 16px;
  padding: 4px;
  border: 1px solid var(--color-alt-5);
  font-family: 'Open Sans';
  font-weight: 700;
  font-size: 16px !important;
}
.whs-guests-select:focus {
  box-shadow: 0 0 1px var(--color-alt), 0 0 8px var(--color-bg-dark),
    1px 0 12px var(--color-bg);
}
</style>